export const exportHeaders = [
    {
         label: "Billto",
         key: "customer_billto_account_number"
     },
     {
         label: "Shipto",
         key: "customer_account_number"
     },
     {
         label: "Practice Name",
         key: "practice_name"
     },
      {
         label: "Current Thrive Status",
         key: "program_type"
     },
     {
         label: "Unlocked Program Enrollment",
         key: "program_enrollment"
     },
     {
         label: "Account Sales Status",
         key: "account_sales_status"
     },
     {
        label: "Added By",
        key: "added_by"
    },
    {
        label: "Added Date",
        key: "added_date"
    },
      {
         label: "Eligibility Source",
         key: "eligibility_source"
     },
     {
        label: "Eligibility Last Evaluated Date",
        key: "eligibility_last_evaluated_date"
    },
      {
         label: "Review Status",
         key: "review_status"
     },
     {
        label: "Last Updated Date",
        key: "updated_date"
    },
     {
        label: "Last Updated By",
        key: "updated_by"
    },
    {
        label: "Prior 365-Day Eligible Sales",
        key: "prior_365_day_eligible_sales"
    },
     
     
 ]